import type { DesignVariant, DetectedElement, Project, ProjectKind } from "./types";

const interiorElements: DetectedElement[] = [
  {
    id: "element-sofa",
    category: "sofa",
    label: "Modularna sofa",
    colourTags: ["bež", "pijesak"],
    styleTags: ["mediteranski", "moderan"],
    materialTags: ["tkanina"],
    featureTags: ["obiteljsko", "lako održavanje"],
    widthCm: 238,
  },
  {
    id: "element-table",
    category: "coffee-table",
    label: "Kameni stolić",
    colourTags: ["bež", "pijesak"],
    styleTags: ["mediteranski", "minimalistički"],
    materialTags: ["kamen"],
    featureTags: ["prirodni materijali", "kompaktno"],
    widthCm: 92,
  },
  {
    id: "element-rug",
    category: "rug",
    label: "Teksturirani tepih",
    colourTags: ["bež", "pijesak"],
    styleTags: ["mediteranski", "skandinavski"],
    materialTags: ["tkanina"],
    featureTags: ["prirodni materijali"],
  },
  {
    id: "element-light",
    category: "lighting",
    label: "Diskretna visilica",
    colourTags: ["smeđa"],
    styleTags: ["moderan", "minimalistički"],
    materialTags: ["metal"],
    featureTags: ["lako održavanje"],
  },
];

const exteriorElements: DetectedElement[] = [
  {
    id: "element-garden",
    category: "garden-set",
    label: "Vrtna garnitura",
    colourTags: ["smeđa"],
    styleTags: ["mediteranski", "moderan"],
    materialTags: ["drvo"],
    featureTags: ["obiteljsko"],
  },
  {
    id: "element-paver",
    category: "paver",
    label: "Svijetli opločnici",
    colourTags: ["bež", "pijesak"],
    styleTags: ["mediteranski"],
    materialTags: ["kamen"],
    featureTags: ["lako održavanje"],
  },
  {
    id: "element-light-outdoor",
    category: "outdoor-light",
    label: "Vanjska rasvjeta",
    colourTags: ["smeđa"],
    styleTags: ["moderan"],
    materialTags: ["metal"],
    featureTags: ["lako održavanje"],
  },
];

const titles = [
  ["Topla mediteranska", "Kamen, lan i maslinasti tonovi stvaraju miran, izvediv prostor."],
  ["Svijetla skandinavska", "Svjetlija paleta i jednostavniji volumeni povećavaju osjećaj prostora."],
  ["Prirodno moderna", "Čiste linije omekšane su drvom, teksturama i toplom rasvjetom."],
  ["Obiteljski praktična", "Otporne površine i lako održavanje bez gubitka karaktera."],
  ["Tihi luksuz", "Manje elemenata, bolji materijali i preciznije proporcije."],
];

const interiorVariantImages = [
  "/images/interior-after-1024.webp",
  "/images/interior-variant-2-1024.webp",
  "/images/interior-variant-3-1024.webp",
  "/images/interior-variant-4-1024.webp",
  "/images/interior-variant-5-1024.webp",
];

export function makeDemoVariants(projectId: string, kind: ProjectKind): DesignVariant[] {
  return titles.map(([title, explanation], index) => ({
    id: `variant-${index + 1}`,
    projectId,
    title,
    explanation,
    style: title.split(" ").slice(1).join(" "),
    estimatedMinCents: 240_000 + index * 65_000,
    estimatedMaxCents: 520_000 + index * 95_000,
    imageUrl: kind === "exterior" ? "/images/exterior-after-1024.webp" : interiorVariantImages[index],
    detectedElements: kind === "exterior" ? exteriorElements : interiorElements,
    productCount: kind === "exterior" ? 9 : 18,
  }));
}

export function createDemoProject(kind: ProjectKind, space: string): Project {
  const created = new Date();
  const expires = new Date(created.getTime() + 7 * 24 * 60 * 60 * 1000);
  return {
    id: crypto.randomUUID(),
    kind,
    space,
    status: "draft",
    preferences: {
      style: "Mediteranski",
      budgetMin: 2_000,
      budgetMax: 8_000,
      colours: ["pijesak", "maslinasta"],
      keep: "",
      remove: "",
      notes: "",
    },
    createdAt: created.toISOString(),
    expiresAt: expires.toISOString(),
  };
}
